import React from 'react';
import { Outlet } from 'react-router-dom';
import { ADMIN_URL_PATH, SUBSCRIPTION_MANAGEMENT_URL_PATH } from './paths';

const SubscriptionManagement = React.lazy(
  () => import('@/features/subscrriptionmanagement/SubscriptionManagement'),
);
export default {
  path: ADMIN_URL_PATH,
  element: <Outlet />,
  children: [
    {
      path: SUBSCRIPTION_MANAGEMENT_URL_PATH,
      element: <SubscriptionManagement />,
    },
  ],
};
